<template>
<div class="chapter">
<div class="inner_page">
<p class="western" id="calibre_pb_0"> <br class="calibre2"/></p>
<h3 class="c1">The Journal</h3>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1"> <br class="calibre2"/></p>
<h3 class="c2">Crimson Skies</h3>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1"> <br class="calibre2"/></p>
<h3 class="c1">By Deborah D. Moore</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_648f5cba11b35594391da1bef1608eec_YkgYR9.ch.fixed.fc.tidied.stylehacked.xfixed_split_001.vue?087cd9f2